<template>
  <Timeline
    :id="id"
    source-type="profile"
    :options="options"
    :widget-class="'widget-timeline'"
    error-message="&lt;div style='padding: 8px 16px; margin: 8px 0; line-height: 20px; border-style: solid; border-width: 1px; border-radius: 4px'&gt;タイムラインを読み込めませんでした。&lt;br /&gt;アカウントが非公開になっている、またはポストが削除された可能性があります。&lt;/div&gt;"
    error-message-class="message-warning"
  ></Timeline>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Timeline } from 'vue-tweet-embed'

export default defineComponent({
  props: {
    id: String,
    tweetLimit: String
  },
  components: {
    Timeline
  },
  computed: {
    options() {
      return {
        id: `profile:${this.id}`,
        tweetLimit: this.tweetLimit,
        lang: 'ja',
        chrome: 'noheader nofooter'
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-warning {
  color: $warning-color;
  border-color: $warning-color;
}
</style>
